"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Webinarreplay = function Webinarreplay(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "WebinarreplayTitle WebinarreplayDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "WebinarreplayTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "WebinarreplayDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M16 .132c-6.623 0-12 5.377-12 12 0 5.023 3.094 9.326 7.477 11.113l-3.795 5.796a.334.334 0 0 0-.057.182c0 .445.362.766.818 1.011.456.245 1.073.444 1.818.614 1.49.338 3.505.545 5.739.545s4.248-.207 5.739-.545c.745-.17 1.362-.369 1.818-.614.456-.245.818-.566.818-1.011a.334.334 0 0 0-.057-.182l-3.795-5.796a12.067 12.067 0 0 0 7.102-8.102.367.367 0 0 0-.705-.204c-1.26 4.847-5.674 8.465-10.92 8.465A11.267 11.267 0 0 1 4.727 12.132C4.727 5.902 9.77.859 16 .859c6.23 0 11.273 5.043 11.273 11.273a.364.364 0 1 0 .727 0c0-6.623-5.377-12-12-12zm0 6.545a5.46 5.46 0 0 0-5.455 5.455A5.46 5.46 0 0 0 16 17.586a5.46 5.46 0 0 0 5.455-5.454A5.46 5.46 0 0 0 16 6.677zm0 .727a4.722 4.722 0 0 1 4.727 4.728A4.722 4.722 0 0 1 16 16.859a4.722 4.722 0 0 1-4.727-4.727A4.722 4.722 0 0 1 16 7.404zm-3.818 16.103a11.976 11.976 0 0 0 7.636 0l3.773 5.75c-.014.067-.085.2-.41.375-.353.19-.91.374-1.613.534-1.405.32-3.384.523-5.568.523-2.184 0-4.163-.204-5.568-.523-.703-.16-1.26-.344-1.614-.534-.324-.174-.395-.308-.409-.375l3.773-5.75z"
  }));
};

Webinarreplay.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Webinarreplay.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Webinarreplay;
exports["default"] = _default;